import { Action } from 'redux';

import { QuickSwitch, QuickSwitchItem } from '../insight/config.insight.model';

import { SuperGroupExtra } from './super-group.hi.model';

export enum ActionType {
    HUMAN_INSIGHT__SUPER_GROUP__SELECT = 'HUMAN_INSIGHT__SUPER_GROUP__SELECT',
    HUMAN_INSIGHT__SUPER_GROUP__SELECT_RESULT = 'HUMAN_INSIGHT__SUPER_GROUP__SELECT_RESULT',
}

export interface SuperGroupSelectAction extends Action<ActionType> {
    superGroup: QuickSwitchItem<SuperGroupExtra>;
}

export const superGroupSelect = (
    superGroup: QuickSwitchItem<SuperGroupExtra>,
): SuperGroupSelectAction => ({
    type: ActionType.HUMAN_INSIGHT__SUPER_GROUP__SELECT,
    superGroup,
});

export interface SuperGroupSelectResultAction extends SuperGroupSelectAction {
    quickSwitch?: QuickSwitch<SuperGroupExtra>;
    filteredItems?: Array<QuickSwitchItem<SuperGroupExtra>>;
}

export const superGroupSelectResult = (
    quickSwitch?: QuickSwitch<SuperGroupExtra>,
    filteredItems?: Array<QuickSwitchItem<SuperGroupExtra>>,
    superGroup?: QuickSwitchItem<SuperGroupExtra>,
): SuperGroupSelectResultAction => ({
    type: ActionType.HUMAN_INSIGHT__SUPER_GROUP__SELECT_RESULT,
    quickSwitch,
    filteredItems,
    superGroup,
});
